import type {
  ComponentPropsWithRef,
  ElementType,
  ForwardedRef,
  FunctionComponent,
  MouseEvent,
  MutableRefObject,
  ReactNode,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import { AnimationWrapper } from '../AnimationWrapper'
import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import type { TypographyTokenNames } from '../Seatbelt2/Foundations/Typography/Typography'
import styles from './LinkButton.module.scss'

export const LinkButton: FunctionComponent<Props> = ({
  children,
  type = 'button',
  textStyle = 'sb-text-body-default-regular',
  icon: Icon,
  disabled = false,
  onClick,
  forwardRef,
  className,
  ...rest
}) => {
  return (
    <button
      className={classnames(styles.button, className)}
      {...(disabled && { 'aria-disabled': 'true' })}
      disabled={disabled}
      onClick={onClick}
      ref={forwardRef}
      type={type}
      {...rest}
    >
      <TypographyV2 textStyle={textStyle} tag="span">
        {Icon && <Icon className={styles.icon} />}
        <AnimationWrapper>{children}</AnimationWrapper>
      </TypographyV2>
    </button>
  )
}

export type Props = {
  children: ReactNode
  type?: HTMLButtonElement['type']
  textStyle?: TypographyTokenNames
  icon?: ElementType
  disabled?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  forwardRef?:
    | ForwardedRef<HTMLButtonElement>
    | MutableRefObject<HTMLButtonElement>
  className?: string
} & ComponentPropsWithRef<'button'>
